import React, { Fragment } from 'react';
import { Intro, MultipleChoice } from 'abbot-core';
import img from '../../assets/images/U1-T2-1-4.svg';

const data = {
  inputType: 'checkbox',
  question:
    'Nutritious food choices can help reduce the risk of developing certain noncommunicable diseases. Which of the following are noncommunicable diseases?  Select all that apply',
  options: [
    {
      label: 'influenza (flu)'
    },
    {
      label: 'heart disease'
    },
    {
      label: 'diabetes'
    },
    {
      label: 'high blood pressure'
    }
  ]
};

const feedback = {
  success: {
    title: 'Correct.',
    body:
      'Influenza is highly contagious and not developed over time. You’ll learn more about noncommunicable diseases in the module'
  },
  error: {
    title: 'Sorry, that’s incorrect.',
    body:
      'Influenza is highly contagious and not developed over time. You’ll learn more about noncommunicable diseases in the module.'
  }
};

const correctInput = {
  [data.question]: [
    data.options[1].label,
    data.options[2].label,
    data.options[3].label
  ]
};

export default {
  title: 'Question 2',
  path: '/prepare/question-2',
  content: (
    <Fragment>
      <Intro
        title="Show What You Know"
        direction="Select the best answer to each question."
        img={img}
      />

      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
      />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/prepare/Question2.js